module.exports = __webpack_public_path__ + "static/img/contract-bg.e5569be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/visa-api/contract-bg.png
// module id = r02k
// module chunks = 4